import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10",
      cy: "10",
      r: "9",
      stroke: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      d: "M7.923 7.73c0-2.266 4.154-2.88 4.154.378 0 1.888-2.643 2.492-2.643 3.398"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "9.434",
      cy: "14.149",
      r: ".755",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }